module.exports = __webpack_public_path__ + "img/IEC13797.0c367eac.png";